// extracted by mini-css-extract-plugin
export var active = "input-search-module--active--vHMXm";
export var clearButton = "input-search-module--clear-button--yjCb3";
export var searchInput = "input-search-module--search-input--nrrB5";
export var smallSearch = "input-search-module--small-search--uue4k";